import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './locales/en.json'
import sl from './locales/sl.json'
import rs from './locales/rs.json'
import gr from './locales/gr.json'
import hr from './locales/hr.json'
import de from './locales/de.json'
import it from './locales/it.json'
import me from './locales/me.json'
import vn from './locales/vn.json'

Vue.use(VueI18n)
const languages = {
    en: en,
    si: sl,
    rs: rs,
    gr: gr,
    hr: hr,
    ba: hr,
    de: de,
    it: it,
    me: me,
    vn: vn
}
export default languages